import React from 'react';
import PropTypes from 'prop-types';
import Parser from 'html-react-parser';
import Loading from '../Loading';
import { useI18n } from 'utils/I18n/context';

const DataComponentTile = ({
    data = [],
    headerNames = [],
    headerNamesArray = false,
    multiLevelHeaderNames: _multiLevelHeaderNames = [],
    columnData = { header: [], body: [] },
    loading = false,
    settings: _settings = false,
    settingKey: _settingKey = '',
    filters: _filters = {},
    className = ''
}) => {
    const { t } = useI18n();
    const staticNames = t?.dataTable || {};
    const getKey = (data) => {
        if (React.isValidElement(data)) {
            return getKey(data.props.children);
        }

        return data;
    };

    const getLabel = (key, id) => {
        if (headerNamesArray) {
            return (
                <span className={'item-title'}>
                    {headerNames[id]}
                </span>
            )
        } else {
            if ('actions' === key) {
                return null;
            }
            return headerNames.map((item) => {
                if (item.keyTitle === key) {
                    return (
                        <span className={'item-title'}>
                        {item.title}
                    </span>
                    )
                }
            })
        }
    };

    return (
        <div className="loading-wrapper">
            {loading && data.length
                ? <div className="loading-wrapper__item"><Loading /></div>
                : null
            }
            <div className="table-responsive">
                <div className={`tiles tile-data ${className}`}>
                        {data.map((item, i) => {
                            let className = item.className;
                            delete item.className;
                            return (
                                <div key={getKey(item.id || i)} className={className}>
                                    {Object.keys(item).map((key, j) => {
                                        const data = columnData.body[j] || {};
                                        let value;

                                        if (typeof item[key] === 'object') {
                                            value = item[key];
                                        } else if (typeof item[key] === 'string'){
                                            value = Parser(item[key]);
                                        }

                                        if(value === undefined) {
                                            return;
                                        }

                                        return (
                                            <div className={key} key={j} {...data}>
                                                {getLabel(key,j)}
                                                {value}
                                            </div>
                                        )
                                    })}
                                </div>
                            )
                        })}
                </div>
                {!data.length
                    ? loading
                        ? <Loading center={true} />
                        : <div className="text-center table-notfound-sign">{ staticNames.noData}</div>
                    : null
                }
            </div>
        </div>
    );
};

DataComponentTile.propTypes = {
    data: PropTypes.array,
    headerNames: PropTypes.array,
    headerNamesArray: PropTypes.bool,
    multiLevelHeaderNames: PropTypes.array,
    columnData: PropTypes.object,
    loading: PropTypes.bool,
    settings: PropTypes.bool,
    settingKey: PropTypes.string,
    filters: PropTypes.object,
    className: PropTypes.string
};

DataComponentTile.defaultProps = {
    data: [],
    headerNames: [],
    headerNamesArray: false,
    multiLevelHeaderNames: [],
    columnData: { header: [], body: [] },
    loading: false,
    settings: false,
    settingKey: '',
    filters: {},
    className: ''
};

export default DataComponentTile;
